import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component, OnDestroy, Optional, ViewChild} from "@angular/core";
import {EntityData, provideEntityModel} from "@fedeltapointofsale/data-client";
import {MyreportEntityModel} from "../myreport-entity.model";
import {
    EmployeeSearchPageComponent
} from "../../../employee/employee/employee-search-page/employee-search-page.component";
import {MyreportDistributionData, MyreportSchedulePatternData} from "../myreport.data";
import {EditPageComponent} from "../../../framework/entity/edit/edit-page/edit-page.component";
import {FUIResponsiveService, FUIStackedPageContextService} from "@fedeltapointofsale/ui";
import {EditParams} from "../../../framework/entity/edit/edit-page/edit-params";
import {TranslateService} from "@ngx-translate/core";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {first, Subscription} from "rxjs";
import {EmployeeEditPageComponent} from "../../../employee/employee/employee-edit-page/employee-edit-page.component";
import {EmployeeData} from "../../../employee/employee/employee.data";

@Component({
    selector: "myreport-edit-page",
    templateUrl: "./myreport-edit-page.component.html",
    styleUrls: ["myreport-edit-page.component.scss"],
    providers: [provideEntityModel(MyreportEntityModel)]
})
export class MyreportEditPageComponent extends AbstractEditPage implements OnDestroy {

    public static EDIT_PARAM_REPORT_PARAMS = "reportParams";
    public static EDIT_PARAM_REPORT_ID = "reportId";
    public static EDIT_PARAM_REPORT_TITLE = "reportTitle";

    EmployeeSearchPageComponent = EmployeeSearchPageComponent;
    EmployeeEditPageComponent = EmployeeEditPageComponent;

    MyreportSchedulePatternData = MyreportSchedulePatternData;

    subscriptions: Subscription = new Subscription();

    constructor(public model: MyreportEntityModel,
                @Optional() stackedPageContextService: FUIStackedPageContextService,
                translateService: TranslateService,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
        if (stackedPageContextService) {
            const editParams: EditParams = stackedPageContextService.params;
            if (editParams.editMode === EditMode.ADD) {
                this.model.data.reportUIId = editParams.params[MyreportEditPageComponent.EDIT_PARAM_REPORT_ID];
                this.model.data.parametersAsString = editParams.params[MyreportEditPageComponent.EDIT_PARAM_REPORT_PARAMS];
                this.model.data.scheduleTemplateData.pattern.isLoaded = true;
                translateService.get(editParams.params[MyreportEditPageComponent.EDIT_PARAM_REPORT_TITLE]).pipe(first()).subscribe(title => this.model.data.report = title);
            } else {
                this.subscriptions.add(this.model.$data.subscribe(() => {
                    this.model.data.parametersAsString = editParams.params[MyreportEditPageComponent.EDIT_PARAM_REPORT_PARAMS];
                }));
            }
        }
    }

    selectNewEmployee(entity: EntityData<any>): void {
        const employee: EmployeeData = <EmployeeData>entity;
        if (this.model.data.distributionList.find(value => value.recuserId === employee.user.userId) == undefined) {
            const distribution: MyreportDistributionData = <MyreportDistributionData>EntityData.create(MyreportDistributionData);
            distribution.employee.employeeId = employee.employeeId;
            distribution.employee.user.firstName = employee.user.firstName
            distribution.employee.user.lastName = employee.user.lastName;
            distribution.employee.user.name = employee.user.name
            distribution.employee.user.userId = employee.user.userId;
            distribution.recuserId = employee.employeeId;
            distribution.employee.contact.email = employee.contact.email;

            this.model.data.distributionList.push(distribution);
        }
    }

    selectEmployee(employees: any[]): void {
        employees.forEach((employee) => {
            if (this.model.data.distributionList.find(value => value.recuserId === employee.userId) == undefined) {
                const distribution: MyreportDistributionData = <MyreportDistributionData>EntityData.create(MyreportDistributionData);
                distribution.employee.employeeId = employee.employeeId;
                distribution.employee.user.firstName = employee.firstName;
                distribution.employee.user.lastName = employee.lastName;
                distribution.employee.user.name = employee.name;
                distribution.employee.user.userId = employee.userId;
                distribution.recuserId = employee.employeeId;
                distribution.employee.contact.email = employee.email;

                this.model.data.distributionList.push(distribution);
            }
        });
    }

    get employeeSearchFilter(): any {
        return {[EmployeeSearchPageComponent.EMAIL_REQUIRED_SEARCH_PARAM]: true};
    }

    updateValueAndValidityForDates(): void {
        this.editPageComponent.formGroup.get("scheduleTemplateData.startDate").updateValueAndValidity();
        this.editPageComponent.formGroup.get("scheduleTemplateData.startTime").updateValueAndValidity();
        this.editPageComponent.formGroup.get("scheduleTemplateData.finishDate").updateValueAndValidity();
        this.editPageComponent.formGroup.get("scheduleTemplateData.finishTime").updateValueAndValidity();
    }

    get hasRecurrencePattern(): boolean {
        return this.model.data.scheduleTemplateData.pattern.patternType != undefined;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
